<div class="preview-waiting">
    <core-helpers-box-loading ></core-helpers-box-loading>
</div>
